// 오행 비율에서 가장 높은 기질. 같은 값이 여럿이면 모두 돌려준다 (순서 때문에 앞의 것이 이기지 않게).
export function topElements(elements) {
  const entries = Object.entries(elements ?? {});
  if (!entries.length) return [];
  const max = Math.max(...entries.map(([, v]) => v));
  return entries.filter(([, v]) => v === max).map(([el]) => el);
}
